<script setup lang="ts">
import { ref } from 'vue';
import Action from './Action.vue';
import Amount from './Amount.vue';
import Details from './Details.vue';
import Position from './Position.vue';
import Wallet from './Wallet.vue';
import useStaking from './useStaking';

const amount = defineModel<number>({
  default: 0,
});

const {
  newAmountStacked,
  newPositionEarnings,
  currentStakedAmount,
  userEarnings,
  sonarwatchEarnings,
  comissions,
  isReady,
} = useStaking(amount);

const isSuccess = ref(false);
</script>

<template>
  <div class="flex flex-col gap-2">
    <Wallet />
    <v-card
      class="bg-theme-light-100 dark:bg-theme-dark-100 rounded-lg"
      :loading="!isReady"
    >
      <div
        v-if="isSuccess"
        class="flex justify-center p-8 bg-primary/20 text-primary flex-col text-center"
      >
        <p class="font-bold">Your staking has been successfully completed!</p>
        <p>
          Your position will be active at
          <a
            href="https://solana.com/staking#delegation-timing-considerations"
            target="_blank"
            class="!underline"
            >next epoch</a
          >.<br />Thank you for trusting SonarWatch to grow your SOL.
        </p>
      </div>
      <Amount v-model="amount" :new-position-earnings="newPositionEarnings" />
      <div class="flex flex-col gap-4 p-8">
        <Position
          :new-amount-stacked="newAmountStacked"
          :apy="userEarnings.userAPY.value"
          :current-amount-staked="currentStakedAmount ?? undefined"
        />
        <Details
          :stake-earnings="userEarnings.stakeEarnings.value"
          :mev-earnings="userEarnings.mevEarnings.value"
          :total-earnings="userEarnings.totalEarnings.value"
          :sonarwatch-earnings="sonarwatchEarnings"
          :mev-comission="comissions.mev.value"
          :stake-comission="comissions.stake.value"
        />
      </div>
      <Action v-model="amount" @success="isSuccess = true" />
    </v-card>
  </div>
</template>
